import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { List, TextField, Typography } from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import StarBorder from "@material-ui/icons/StarBorder";
import ListItemIcon from "@material-ui/core/ListItemIcon";
const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#ff4717",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  theadingstyles: {
    background: "rgb(26 26 49)",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",
  },
  active:{
    color: "#ff4717 !important",
   cursor:"pointer"
 },
 inactive:{
    color:"black",
   cursor:"pointer"
 },
  transformerlist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    },
  },
}));

export default function TrendsList(props) {
  const classes = useStyles();
  const {transformerList,selectedTransformerList,setTransformerSelectedId} = props;

  const transformerSelectedId = (row) =>{
    debugger
    console.log("row",row)
    let transArryList = selectedTransformerList;
    let transKeyIndex = transArryList.indexOf(row);
    if(transKeyIndex == -1){
      transArryList.push(row);
    }else{
      transArryList.splice(transKeyIndex,1);
    }
    setTransformerSelectedId(transArryList);
  }
  return (
    <div>
      <Grid container fluid="md" spacing={3}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            align="left"
            className={clsx(classes.heading, classes.theadingstyles) + " bai-font"}
          >
            Asset List
          </Typography>
          <Paper
            className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto" }}
          >
            <listStyled component="nav" className="scroll-list">
              {transformerList.length
                ? transformerList.map((row, index) => {
                    debugger
                  const indexTrans = selectedTransformerList.indexOf(row);
                  return (
                    <ListItem textAlign="left" key={`${row.tranformerName}_${index}`}
                      className={clsx(classes.transformerlist, "transformerlist", indexTrans >-1? classes.active : classes.inactive)}
                      button
                      onClick={(e) => {
                        transformerSelectedId(row)
                      }}
                      selected={indexTrans>-1?true:false}
                    >
                      <ListItemText>{row.tranformerName}</ListItemText>
                    </ListItem>
                  )
                })
                : "No data found"}
            </listStyled>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
